// Browser substitute for ./middleware, wired via the package.json `browser`
// field. Keeps every named export resolvable in client bundles (Turbopack
// hard-errors on imports of names a false-mapped module lacks).
const serverOnly = (name: string) => () => {
  throw new Error(
    `@mc/next-common: ${name} is server-only and cannot run in the browser`,
  )
}

export const trackPageView: typeof import('./middleware').trackPageView =
  serverOnly('trackPageView')

export const persistAdId: typeof import('./middleware').persistAdId =
  serverOnly('persistAdId')

// Compile-time parity guard: errors when ./middleware gains an export this stub lacks.
export const _exportParity: Omit<
  typeof import('./middleware'),
  keyof typeof import('./middleware.browser')
> = {}
